import { Plus } from "lucide-react";
import { Switch } from "@/components/ui/switch";
import { Btn, Loading, PageHead, Panel, RowTools, SaveBtn, inputCls, move, useSiteDraft } from "@/admin/ui";

export default function MenuEditor() {
  const { draft, patch, save, saving } = useSiteDraft(["menu"]);
  if (!draft) return <Loading />;
  const menu = draft.menu;
  const set = (v) => patch("menu", v);
  const upd = (i, k, v) => set(menu.map((m, j) => (j === i ? { ...m, [k]: v } : m)));
  return (
    <div className="max-w-4xl">
      <PageHead title="Menu" desc="Genres and custom links shown in the menu's scrolling row (and the footer). For a genre, the value must match the genre name on your products.">
        <SaveBtn save={save} saving={saving} />
      </PageHead>
      <Panel className="space-y-2" data-testid="menu-list">
        <div className="hidden sm:grid grid-cols-[110px_1fr_1fr_90px_110px] gap-3 label-caps text-[10px] text-zinc-500 px-1">
          <span>Type</span><span>Menu label</span><span>Genre name / link URL</span><span>Visible</span><span />
        </div>
        {menu.map((m, i) => (
          <div key={m.id || i} className={`grid sm:grid-cols-[110px_1fr_1fr_90px_110px] gap-3 items-center ${m.hidden ? "opacity-50" : ""}`} data-testid={`menu-row-${i}`}>
            <select value={m.type} onChange={(e) => upd(i, "type", e.target.value)} className={inputCls} data-testid={`menu-type-${i}`}>
              <option value="genre">Genre</option><option value="link">Link</option>
            </select>
            <input value={m.label} onChange={(e) => upd(i, "label", e.target.value)} className={inputCls} data-testid={`menu-label-${i}`} />
            <input value={m.value} onChange={(e) => upd(i, "value", e.target.value)} placeholder={m.type === "link" ? "/shop?q=… or https://…" : "Genre name"} className={inputCls} data-testid={`menu-value-${i}`} />
            <Switch checked={!m.hidden} onCheckedChange={(v) => upd(i, "hidden", !v)} data-testid={`menu-visible-${i}`} />
            <RowTools i={i} len={menu.length} onMove={(d) => set(move(menu, i, d))} onDelete={() => set(menu.filter((_, j) => j !== i))} testid={`menu-${i}`} />
          </div>
        ))}
        <div className="flex gap-2 pt-3">
          <Btn variant="outline" onClick={() => set([...menu, { type: "genre", label: "New genre", value: "New genre", hidden: false }])} data-testid="menu-add-genre"><Plus className="w-4 h-4" /> Add genre</Btn>
          <Btn variant="outline" onClick={() => set([...menu, { type: "link", label: "New link", value: "/shop", hidden: false }])} data-testid="menu-add-link"><Plus className="w-4 h-4" /> Add link</Btn>
        </div>
      </Panel>
    </div>
  );
}
